import { cva } from 'class-variance-authority';

/**
 * The text control surface.
 *
 * No `outline-none` anywhere in this file. The global `:focus-visible` rule in
 * `src/styles/globals.css` paints the focus ring; removing it here would make
 * keyboard operation invisible, and that is a release blocker rather than a
 * styling preference.
 */
export const controlStyles = cva(
  [
    'w-full rounded-control border bg-surface-raised text-content',
    'transition-colors',
    'placeholder:text-content-subtle',
    'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-content-muted',
  ],
  {
    variants: {
      size: {
        sm: 'h-8 px-2.5 text-xs',
        md: 'h-9 px-3 text-sm',
      },
      invalid: {
        true: 'border-critical',
        false: 'border-border hover:border-border-strong',
      },
    },
    defaultVariants: {
      size: 'md',
      invalid: false,
    },
  },
);

/** Label, hint and error text. Grouped so the field shell reads as one unit. */
export const fieldStyles = {
  root: 'flex w-full flex-col gap-1.5',
  label: 'text-sm font-medium text-content',
  hint: 'text-xs text-content-muted',
  error: 'text-xs text-critical',
  /** Keeps the label available to assistive technology while hiding it visually. */
  visuallyHidden: 'sr-only',
} as const;